import type { ReactNode } from 'react'
import { Toaster } from 'sonner'
import { QueryProvider } from './QueryProvider'

interface AppProvidersProps {
  children: ReactNode
}

/**
 * Combined providers wrapper
 * Provides: QueryClient (React Query), Router is handled separately
 */
export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryProvider>
      {children}
      <Toaster position="bottom-right" richColors />
    </QueryProvider>
  )
}
